import { render } from "./FrontPage.vue?vue&type=template&id=201fa9a2"
import script from "./FrontPage.vue?vue&type=script&lang=ts"
export * from "./FrontPage.vue?vue&type=script&lang=ts"
script.render = render

export default script